/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { PerformanceObserverEntryTypes } from '../../const.tsx';
import { EntriesBuffer } from '../buffer/index.tsx';

let pe: PerformanceObserver | null = null;

const getObserver = (): PerformanceObserver => {
	if (pe !== null) {
		return pe;
	}
	pe = new PerformanceObserver((list) => {
		list.getEntries().forEach((entry) => {
			if (entry.entryType === PerformanceObserverEntryTypes.LayoutShift) {
				EntriesBuffer[PerformanceObserverEntryTypes.LayoutShift].push(entry);
			}
			if (entry.entryType === PerformanceObserverEntryTypes.LongTask) {
				EntriesBuffer[PerformanceObserverEntryTypes.LongTask].push(entry);
			}
		});
	});

	return pe;
};

export const startLSObserver = (): void => {
	getObserver().observe({
		type: PerformanceObserverEntryTypes.LayoutShift,
		buffered: true,
	});
};

export const startLTObserver = (): void => {
	getObserver().observe({ type: PerformanceObserverEntryTypes.LongTask, buffered: true });
};
